export class IraqwText {
  paragraphHeaders = [
    'Villages & Home Life',
    'Religion',
    'Economy',
    'Iraqw Culture Center Map'
  ];

  paragraphs = [
    `<p class="generated-p">
            The Iraqw people, also known as the Wambulu people by Swahili speakers, are a group of people
            that live near Karatu, Tanzania, in the areas comprising the <a class="generated-a"
            routerLink="../../national-parks/lake-manyara">Manyara</a> region of Tanzania. According to most recent estimates,
            around one million Iraqw people live in Tanzania. While it is not exactly known when the Iraqw came to Tanzania, there are an estimated 200 clans of Iraqw
            tribes thriving today that have blended together a magnificent group of people and cultures over history. Many Iraqw people
            claim a genealogical connection to Iraq, but, perhaps surprisingly, are predominantly Christian. However, there is significant
            dispute regarding the true origin of the Iraqw people, with some scholars suggesting the connection to Iraq is a fallacy contrived
            by people who believe in the ethnical inferiority of native African peoples.
          </p>`,
    `<p class="generated-p">
          Iraqw villages and huts serve a main role in the Iraqw society. Their huts are built with woven
          sticks patted down with mud and enclosed with a straw or metal sheet roof. Inside you will find many rooms, each serving a unique purpose:
          <ul>
            <li>
             Tool room for men</li>
            <li>
            Tool room for women</li>
            <li>Room to store cattle</li>
            <li>Occasionally, an underground room</li>
        </ul>
          The underground rooms were originally built to help protect themselves from the Maasai. Throughout history, the Maasai and Iraqw have had
          their fair share of differences and have often been warring communities. Even today, hints of animosity still remain.</p>
          <p class="generated-p">
            Within the huts, social rules are at play. Each room is divided by gender. Men, their tools
            and their equipment are to reside in one room only to be accessed by the males of the household,
            while females, their tools and their equipment resides in a separate section of the home only to be accessed by
            the women of the home.
          </p>`,
    `<p class="generated-p">
            Even with most Iraqw people practicing either Christianity or Islam, the Iraqw people still remain
            devoted to their own way of life and religion. Their religion is centered around two deities,
            one female and the other male.</p>
            <blockquote class="lead text-fg mb-4">The Iraqw believe their ancestors play an active, important role in their lives.</blockquote>
            <p class="generated-p">
            They believe that when their own lives come to an end, they too become a spiritual ancestor and
            move to an underground world while still maintaining good relations with the living world.
          </p>`,
    `<p class="generated-p">
            In the Iraqw tribes, one's wealth is determined by the number of animals they own. The Iraqw are
            known to be skilled in agriculture and livestock breeding. Traditionally, the Iraqw grow maize,
            beans, potatoes, and onions. They also breed sheep, goats and chicken. When they are not busy tending to their
            animals and crops, you may find the men blacksmithing or partaking in other metal work and the women crafting pottery or
            making rugs for their homes.
          </p>`,
    `<p class="generated-p">The Iraqw Culture Center is located in Karatu, Tanzania,
    near the <a class="generated-a" href="../../national-parks/ngorongoro">Ngorongoro Conservation Area</a>.
    On Kopa Tours <a class="generated-a" href="../../safari/culture-quest-safari">Culture Quest Safari</a>, your guide will take
    you to the Iraqw Culture Center for an immersion into Iraqw Culture where you can discover these cultural intricacies for yourself.
    After your visit, you will continue on in your safari into the Ngorongoro Crater.
    </p>`
  ];

  factsHeader = 'Iraqw Facts';
  facts = [
    'Tanzania has somewhere around 120 different groups of indigenous peoples.\n',
    `A large number of the Iraqw tribe members claim to have historical connections to Iraq in the Middle East.`,
    `The Iraqw are known for being excellent cattle herders. An important trade tool in Iraqw culture is cattle dung due to its use as a fertilizer.`
  ];
  badge = `<i><span class="badge badge-secondary px-2 py-1">Cultural Immersion</span></i>`;
}
